var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHyperlinkAboutUs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 12.2441C14.5376 12.2441 17 9.78171 17 6.74414C17 3.70657 14.5376 1.24414 11.5 1.24414C8.46243 1.24414 6 3.70657 6 6.74414C6 9.78171 8.46243 12.2441 11.5 12.2441Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.925 21.7564C11.886 20.6404 11.25 19.1444 11.25 17.5004C11.25 15.8174 11.917 14.2884 13.001 13.1644C12.511 13.1264 12.01 13.1064 11.5 13.1064C8.178 13.1064 5.237 13.9374 3.411 15.1824C2.018 16.1324 1.25 17.3394 1.25 18.6064V20.0564C1.25 20.5074 1.429 20.9404 1.748 21.2584C2.067 21.5774 2.499 21.7564 2.95 21.7564H12.925Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.5 12.25C14.602 12.25 12.25 14.602 12.25 17.5C12.25 20.398 14.602 22.75 17.5 22.75C20.398 22.75 22.75 20.398 22.75 17.5C22.75 14.602 20.398 12.25 17.5 12.25ZM16.75 17.5V20C16.75 20.414 17.086 20.75 17.5 20.75C17.914 20.75 18.25 20.414 18.25 20V17.5C18.25 17.086 17.914 16.75 17.5 16.75C17.086 16.75 16.75 17.086 16.75 17.5ZM17.5 14.25C18.052 14.25 18.5 14.698 18.5 15.25C18.5 15.802 18.052 16.25 17.5 16.25C16.948 16.25 16.5 15.802 16.5 15.25C16.5 14.698 16.948 14.25 17.5 14.25Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHyperlinkAboutUs);
export default __webpack_public_path__ + "static/media/hyperlink-about-us.67d2fb7e47f014eff8abcfcb1c51e513.svg";
export { ForwardRef as ReactComponent };